import React from 'react';
import classNames from 'classnames';
import { withStyles } from './../../../../themes/default';
import CONSTANT from './../../../../config/constant';

const styles = theme => ({
  root: {

    position: 'fixed',
    left: `${ CONSTANT.sidebar.width + theme.spacing.unit * 3 }px`,
    bottom: 0,
    width: `calc(100% - ${ CONSTANT.sidebar.width + (theme.spacing.unit * 6) }px)`,
    zIndex: 999,
    background: '#efebeb',
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    paddingLeft: theme.spacing.unit * 4,
    paddingRight: theme.spacing.unit * 4

  },
  disablePadding: {
    paddingTop: 0,
    paddingBottom: 0
  }
});

const FormActions = ({children, classes, disablePadding, ...rest}) => {

  return (
    <div className={ classNames(classes.root, disablePadding ? classes.disablePadding : null ) }>
      { children }
    </div>
  )

}

export default withStyles(styles)(FormActions);
